export default function () {
  if (this.$route.name === 'EditContent') {
    this.loadContent()
  }
}
